<template>
<div>
  <div class="Home">
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/home.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <div class="text-center" id="welcome">
    </div>
    <h2>CHIME/FRB Post-Realtime Web Network</h2>
  <b-button size="sm" @click.stop="showWaterfaller" class="mr-1">
    Online Waterfaller
  </b-button>
  <b-button size="sm" @click.stop="showOps" class="mr-1">
    L1 Operations Page
  </b-button>
  <b-button size="sm" @click.stop="showEventViewer" class="mr-1">
    Event Viewer
  </b-button>
  <b-button size="sm" @click.stop="showIBV" class="mr-1">
    Incoherent Beam Viewer
  </b-button>
  <div id="Waterfaller" style="display:none">
    <b-embed type="iframe" aspect="16by9" src="https://frb.chimenet.ca/waterfaller"></b-embed>
  </div>
  <div id="Operations" style="display:none">
    <b-embed type="iframe" aspect="16by9" src="https://frb.chimenet.ca/ops"></b-embed>
  </div>
  <div id="eventViewer" style="display:none">
    <b-embed type="iframe" aspect="16by9" src="https://frb.chimenet.ca"></b-embed>
  </div>
  <div id="IBV" style="display:none">
    <b-embed type="iframe" aspect="16by9" src="https://frb.chimenet.ca/ibv/"></b-embed>
  </div>
  <div>
    <b-embed type="iframe" aspect="16by9" src="https://frb.chimenet.ca/chimefrb/astro_events/clock/"></b-embed>
  </div>
  </div>
</div>
</template>
<script>
import { AuthVerificationMixin } from './mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl
    }
  },
  mounted () {
    document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
    this.reloadWindow()
  },
  methods: {
    showWaterfaller () {
      // Fetch source plot
      // this.$root.$emit('bv::show::modal', 'modalsource', button)
      var x = document.getElementById('Waterfaller')
      var y = document.getElementById('Operations')
      var z = document.getElementById('eventViewer')
      var u = document.getElementById('IBV')
      u.style.display = 'none'
      y.style.display = 'none'
      z.style.display = 'none'
      if (x.style.display === 'none') {
        x.style.display = 'block'
      } else {
        x.style.display = 'none'
      }
    },
    showOps () {
      // Fetch source plot
      // this.$root.$emit('bv::show::modal', 'modalsource', button)
      var x = document.getElementById('Operations')
      var y = document.getElementById('Waterfaller')
      var z = document.getElementById('eventViewer')
      var u = document.getElementById('IBV')
      u.style.display = 'none'
      y.style.display = 'none'
      z.style.display = 'none'
      if (x.style.display === 'none') {
        x.style.display = 'block'
      } else {
        x.style.display = 'none'
      }
    },
    showIBV () {
      // Fetch source plot
      // this.$root.$emit('bv::show::modal', 'modalsource', button)
      var x = document.getElementById('IBV')
      var y = document.getElementById('Operations')
      var z = document.getElementById('Waterfaller')
      var u = document.getElementById('eventViewer')
      u.style.display = 'none'
      y.style.display = 'none'
      z.style.display = 'none'
      if (x.style.display === 'none') {
        x.style.display = 'block'
      } else {
        x.style.display = 'none'
      }
    },
    showEventViewer () {
      // Fetch source plot
      // this.$root.$emit('bv::show::modal', 'modalsource', button)
      var x = document.getElementById('eventViewer')
      var z = document.getElementById('Operations')
      var y = document.getElementById('Waterfaller')
      var u = document.getElementById('IBV')
      u.style.display = 'none'
      y.style.display = 'none'
      z.style.display = 'none'
      if (x.style.display === 'none') {
        x.style.display = 'block'
      } else {
        x.style.display = 'none'
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Home.vue